mutation EditionTestEmailSend($input: EditionTestEmailSendInput!) {
    editionTestEmailSend(input: $input) {
        count
    }
}
